// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__ewaB9","content":"Banner_content__UuUIi"};